import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSportConfiguration } from "~hooks/useSportConfiguration.ts";
import CustomSelect from "../CustomSelect";

type Props = {
  className?: string;
  disabled?: boolean;
  defaultValue?: string | string[];
  placeholder?: string;
  multiple?: boolean;
  value?: string | string[];
  onChange?: (value: string | string[] | undefined) => void;
  width?: number;
  availableStatuses?: string[];
};

const FilterSelectFixtureStatus = (props: Props) => {
  const { availableStatuses, className, disabled, defaultValue, multiple } = props;
  const { fixtureStatuses } = useSportConfiguration();
  const { formatMessage } = useIntl();

  const options = useMemo(
    () =>
      (availableStatuses ?? fixtureStatuses).map((value) => ({
        value,
        label: formatMessage({ id: `fixtureStatus.${value}` }),
      })),
    [fixtureStatuses, formatMessage, availableStatuses],
  );

  return (
    <CustomSelect
      style={{ minWidth: props.width || "130px" }}
      value={props.value}
      defaultValue={defaultValue}
      onChange={(value) => {
        if (multiple) {
          props.onChange?.(value as string[] | undefined);
        } else {
          props.onChange?.(value as string | undefined);
        }
      }}
      options={options}
      placeholder={props.placeholder || <FormattedMessage id="status" />}
      allowClear
      className={className}
      disabled={disabled}
      mode={multiple ? "multiple" : undefined}
    />
  );
};

export default FilterSelectFixtureStatus;
